import React from 'react';
import { OfferBox } from '../ui/OfferBox';
export function SpecialOffer() {
  return <section className="w-full bg-white px-4 py-16 md:py-24" data-id="element-265" data-mp="33hgwztojhchq">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1fr_1fr] lg:items-center" data-id="element-266" data-mp="33jbhx7zt94lt">
        <div className="text-center lg:text-left" data-id="element-267" data-mp="3ifso7kt57t1i">
          <p className="font-display text-sm font-extrabold uppercase tracking-wide text-blue md:text-base" data-id="element-268" data-mp="3df51vcfv00dm">The special offer</p>
          <h2 className="mt-3 text-balance font-display text-[32px] font-black leading-[1.05] tracking-tight text-heading md:text-5xl" data-id="element-269" data-mp="3rdl7f01zjku6">
            Start Building Your Organized Hair Restoration Reference Library Today
          </h2>
          <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-body md:text-lg" data-id="element-270" data-mp="51fm56o4r7sm">
            <p data-id="element-271" data-mp="2ulj64yum3n">You don’t need to keep adding disconnected documents to your existing collection.</p>
            <p className="font-semibold text-heading" data-id="element-272" data-mp="dxx0eirsjlsl">
              HAIR TRANSPLANT BLUEPRINT™ brings together related educational topics, visual references, and practical
              documentation resources in one organized system.
            </p>
            <p data-id="element-273" data-mp="2pgwbqklz13fn">Review the volumes, explore the worksheets, and adapt the relevant materials to your professional setting.</p>
          </div>
        </div>
        <OfferBox ctaLabel="Get Hair Transplant Blueprint™" ctaSub="Digital product · No recurring subscription" data-id="element-274" data-mp="2uhak63rhife7" />
      </div>
    </section>;
}